import * as tslib_1 from "tslib";
import { ElementRef } from '@angular/core';
import { InterfaceService } from "@app/interfaces";
import { BehaviorSubject } from "rxjs";
import { BsModalRef } from "ngx-bootstrap";
import { DomSanitizer } from "@angular/platform-browser";
import { AddOpportunityService } from "@app/features/customers/add-opportunity/service/add-opportunity.service";
import { AuthService } from "@app/core";
import * as i0 from "@angular/core";
import * as i1 from "ngx-bootstrap/modal";
import * as i2 from "@angular/platform-browser";
import * as i3 from "../../features/customers/add-opportunity/service/add-opportunity.service";
import * as i4 from "../../core/auth/auth.service";
var createHtmlToPdfService = /** @class */ (function (_super) {
    tslib_1.__extends(createHtmlToPdfService, _super);
    function createHtmlToPdfService(bsModalRef, sanitizer, opportunityService, authService) {
        var _this = _super.call(this) || this;
        _this.bsModalRef = bsModalRef;
        _this.sanitizer = sanitizer;
        _this.opportunityService = opportunityService;
        _this.authService = authService;
        _this.pdfDatamake = {
            htmldata: [],
            style: [],
            countryName: '',
            googleFontLink: [],
            pdfVersion: '',
            opportunitiesProposalID: '',
            proposalStatus: '',
            opportunityId: '',
        };
        _this.normalTableStyles = [];
        _this.pagesDataList = [];
        _this.defectEnabled = false;
        _this.defectDetails = new BehaviorSubject(null);
        _this.defectDetails$ = _this.defectDetails.asObservable();
        return _this;
    }
    createHtmlToPdfService.prototype.opportunitiesPages = function (opportunityId, proposalId, body) {
        var _this = this;
        this.sendtoCustomerLoading = true;
        this.opportunityProposalId = proposalId;
        this.opportunityId = opportunityId;
        this.opportunityService.getOpportunityPages(opportunityId, proposalId, true).subscribe(function (responseData) {
            if (responseData) {
                _this.proposalPages = responseData['opportunityPages'];
                _this.PricingSectionAdvanceStyles = responseData['styles'];
                _this.pricingSummaryAdvanceStyles = responseData['summaryStyles'];
                _this.hasSMSModuleAccess = responseData['hasSMSAccess'];
                _this.pricingSectionDetails = responseData['pricingSection'];
                _this.proposalVersion = responseData['currentProposalVersion'];
                /* for (let i = 0; i < this.pricingSummaryAdvanceStyles.length; i++) {
                     this.pricingSummaryAdvanceStyles[i] = JSON.parse(this.pricingSummaryAdvanceStyles[i]['value']);
                 }*/
                var collectionOfPages = _this.proposalPages.flatMap(function (arr) {
                    if (arr.hasOwnProperty('pages')) {
                        arr.pages.forEach(function (page) { return page['option'] = arr['optionName']; });
                        return arr.pages;
                    }
                    else {
                        return [];
                    }
                });
                _this.proposalVersion = responseData['currentProposalVersion'];
                _this.proposalPages = collectionOfPages;
                /*this.proposalPages.forEach((page, index) => {
                    this.pricingSectionDetails.forEach((ps) => {
                        const pricingSectionNameId = `pricingSectionName_${ps.sectionId}`;
                        if(page.value.includes(pricingSectionNameId)) {
                            const htmlElement = document.createElement('div');
                            htmlElement.innerHTML = page.value.trim();
                            const psJquery = $(htmlElement).find(`#${pricingSectionNameId}`)
                            if(psJquery && psJquery[0]) {
                                const regex2 = /^Pricing section {2}\d+$/;
                                const regex = /^Pricing section \d+$/;
                                if(regex.test(psJquery[0]['innerText'] || regex2.test(psJquery[0]['innerText']) {
                                    psJquery.html('');
                                    page.value = htmlElement.innerHTML;
                                }
                            }
                        }
                    });
                });*/
                _this.loadFrame(body);
            }
        });
    };
    createHtmlToPdfService.prototype.loadFrame = function (body) {
        this.bodyHtmlContent = body;
        this.pdfDatamake.pdfVersion = this.proposalVersion;
        this.pdfDatamake.proposalStatus = this.proposalSendStatus;
        if (this.pdfDatamake.proposalStatus == 'sent' && this.proposalPdfDetails) {
            this.PdfFilesData = this.proposalPdfDetails;
            this.Url = this.proposalPdfDetails['url'];
        }
        if (body) {
            var attrStyles = this.getAllOtherStyles();
            for (var i = 0; i < attrStyles.length; i++) {
                this.normalTableStyles.push(attrStyles[i]);
            }
            this.checkingPricingSectionsTotalGrants(body);
            this.findEmptyPages(body);
            // this.findReplaceIframeVideoElement(body);
            // this.updateStylesToDocument(this.normalTableStyles, 'normalTable')
            // this.updateStylesToDocument(this.PricingSectionAdvanceStyles, 'pricingSection');
            // this.updateStylesToDocument(this.pricingSummaryAdvanceStyles, 'pricingSummary');
            this.getCsPageList();
        }
    };
    createHtmlToPdfService.prototype.getAllOtherStyles = function () {
        var styles = [];
        var block = $(this.bodyHtmlContent).contents().find('.fr-element.froala-table.normal-table-width').find('table');
        if ($(block).length > 0) {
            $(block).each(function (i, value) {
                var x = $(value).attr('data-styling');
                if (x) {
                    var y = JSON.parse(x).advancedStyle;
                    y.isNormalTable = true;
                    styles.push(y);
                }
            });
        }
        return styles;
    };
    createHtmlToPdfService.prototype.checkingPricingSectionsTotalGrants = function (body) {
        if (!this.pricingSectionDetails.length)
            return;
        for (var i = 0; i < this.pricingSectionDetails.length; i++) {
            var items = this.pricingSectionDetails[i];
            var sectionId = items['sectionId'];
            var grandTotal = items['grandTotal'];
            if (!sectionId || grandTotal === undefined)
                return;
            var findTable = body.querySelector("#cs_dynamic_styling_" + sectionId);
            if (!findTable)
                return;
            var grandTotalElem = findTable.querySelector("#grand_total_" + sectionId);
            if (!grandTotalElem) {
                this.proposalValueMismatch = true;
                this.proposalValueMismatchError = true;
                break;
            }
            var getValue = grandTotalElem.textContent.trim();
            if (getValue !== grandTotal) {
                this.proposalValueMismatch = true;
                this.proposalValueMismatchError = true;
                this.sendButtonDisabled = true;
                break;
            }
            else {
                this.proposalValueMismatch = false;
                this.proposalValueMismatchError = false;
            }
        }
    };
    createHtmlToPdfService.prototype.findEmptyPages = function (body) {
        var child = body.querySelectorAll('.cs_page');
        child.forEach(function (page) {
            if (!page) {
                return;
            }
            if ($(page).find('.acceptance-margin') && $(page).find('.acceptance-margin').length && $(page).find('.acceptance-margin').hasClass('acceptance-margin')) {
                return;
            }
            $(page).find('.block-selected').removeClass('block-selected');
            $(page).find('#block-type-helper').remove(); //TODO  for older template
            $(page).find('.block-type-helper').remove(); //TODO for new template
            var titleElements = page.querySelectorAll('[tag="Title"]');
            var textareaElements = page.querySelectorAll('[tag="Textarea"]');
            var imageElements = page.querySelectorAll('[tag="Image"]');
            var videoElements = page.querySelectorAll('[tag="Video"]');
            var tableElements = page.querySelectorAll('[tag="Table"]');
            var pricingsectionElements = page.querySelectorAll('[tag="pricingsection"]');
            var addonElements = page.querySelectorAll('[tag="Addon"]');
            var optionspricingbreakupElements = page.querySelectorAll('[tag="Summary"]');
            var defectElements = page.querySelectorAll('[tag="Defect"]');
            function hasNonEmptyTextContent(element) {
                return element.textContent.trim() !== '';
            }
            function processTableElement(elem) {
                var tdElements = elem.querySelectorAll('td');
                var hasText = Array.from(tdElements).some(hasNonEmptyTextContent);
                if (!hasText) {
                    $(elem).addClass('editorHideShowElement');
                }
            }
            titleElements.forEach(function (elem) {
                if (!hasNonEmptyTextContent(elem)) {
                    $(elem).addClass('editorHideShowElement');
                }
            });
            textareaElements.forEach(function (elem) {
                if (!hasNonEmptyTextContent(elem)) {
                    $(elem).addClass('editorHideShowElement');
                }
            });
            imageElements.forEach(function (elem) {
                if ($(elem).find('.img-btn').length) {
                    $(elem).addClass('editorHideShowElement');
                }
            });
            videoElements.forEach(function (elem) {
                if ($(elem).find('.img-btn').length) {
                    $(elem).addClass('editorHideShowElement');
                }
            });
            tableElements.forEach(processTableElement);
            //pricing section table
            if (pricingsectionElements && pricingsectionElements.length) {
                for (var i = 0; i < pricingsectionElements.length; i++) {
                    var getTableElement = void 0;
                    if ($(pricingsectionElements[i]).attr('tag-name') === 'Defects') {
                        var emptyPricing = $(pricingsectionElements[i]).find('#defect-summary-section').find("[id^='grand_total_']").text();
                        if (emptyPricing && emptyPricing == '0.00') {
                            $(pricingsectionElements[i]).closest('.row-item').addClass('editorHideShowElementDefectValueZero');
                        }
                    }
                    else {
                        getTableElement = $(pricingsectionElements[i]).find('table');
                        if (getTableElement && getTableElement.length) {
                            var getPricingTable = $(pricingsectionElements[i]).find('tbody tr td');
                            if (getPricingTable && getPricingTable[0].innerHTML == '') {
                                $(getPricingTable).closest('.row-item').addClass('editorHideShowElement');
                            }
                        }
                    }
                }
            }
            //pricing section table addons
            if (addonElements && addonElements.length) {
                for (var i = 0; i < addonElements.length; i++) {
                    var getTableElement = $(addonElements[i]).find('table');
                    if (getTableElement && getTableElement.length) {
                        var getPricingTable = $(addonElements[i]).find('tbody tr td');
                        if (getPricingTable && getPricingTable[0].innerHTML == '') {
                            $(getPricingTable).closest('.cs_block_s').addClass('editorHideShowElement');
                        }
                    }
                }
            }
            if (optionspricingbreakupElements && optionspricingbreakupElements.length) {
                for (var i = 0; i < optionspricingbreakupElements.length; i++) {
                    var getTableSummary = $(optionspricingbreakupElements[i]).find('table');
                    if (getTableSummary && getTableSummary.length) {
                        var getTbody = $(getTableSummary).find('tbody tr');
                        if (getTbody && getTbody.length) {
                            var getPricingTable = $(getTbody).find('td');
                            if (getPricingTable && getPricingTable[0].innerHTML.trim() == '') {
                                $(optionspricingbreakupElements[i]).closest('.row-item').addClass('editorHideShowElement');
                            }
                        }
                        else {
                            $(optionspricingbreakupElements[i]).closest('.row-item').addClass('editorHideShowElement');
                        }
                    }
                }
            }
            if (defectElements && defectElements.length) {
                for (var i = 0; i < defectElements.length; i++) {
                    var getDefectElement = $(defectElements[i]).find('#defect-summary-section');
                    if (getDefectElement && getDefectElement.length == 0) {
                        $(getDefectElement).closest('.cs_block_s').addClass('editorHideShowElement');
                    }
                }
            }
            var editorHideShowElements = page.querySelectorAll('.editorHideShowElement');
            var totalElementsLength = titleElements.length + textareaElements.length + imageElements.length + videoElements.length + tableElements.length + pricingsectionElements.length + addonElements.length + optionspricingbreakupElements.length + defectElements.length;
            var editorHideShowLength = editorHideShowElements.length;
            if (totalElementsLength === editorHideShowLength) {
                var eleBackImage = $(page).css('background-image');
                var checkBackgroungColour = $(page).css('background-color');
                var findBackgroundHeader = $(page).find('div[id^="headerandfooter_header_"]').css('background-image') || '';
                var findBackgroundFooter = $(page).find('div[id^="headerandfooter_footer_"]').css('background-image') || '';
                if ((eleBackImage === 'none' || !eleBackImage) &&
                    (checkBackgroungColour === 'rgb(255, 255, 255)' || !checkBackgroungColour) &&
                    (findBackgroundHeader === 'none' || !findBackgroundHeader) &&
                    (findBackgroundFooter === 'none' || !findBackgroundFooter)) {
                    $(page).addClass('over-all-page-hide');
                }
            }
        });
        this.findTableEmptyColumn(body);
        this.findReplaceRow(body);
        // this.checkCoverBackPageBackground(body);
    };
    createHtmlToPdfService.prototype.findTableEmptyColumn = function (body) {
        var findTableEmptyPage = body.getElementsByClassName('notes');
        for (var index = 0; index < findTableEmptyPage.length; index++) {
            var element = findTableEmptyPage[index];
            if (element.value == '') {
                $(element).addClass("contentPage-empty-notes-row");
            }
        }
    };
    createHtmlToPdfService.prototype.findReplaceRow = function (body) {
        var child = body.querySelectorAll('.cs_page');
        child.forEach(function (element) {
            var textNode = $(element).find('.desc');
            if (textNode.length) {
                for (var i = 0; i < textNode.length; i++) {
                    var textValue = $(textNode[i]).val();
                    var tempDiv = "<div class=\"desc ignore-sorting\">" + textValue + "</div>";
                    $(textNode[i]).replaceWith(tempDiv);
                }
            }
            var textarea = $(element).find('.notes');
            if (textarea.length) {
                for (var i = 0; i < textarea.length; i++) {
                    var textareaValue = $(textarea[i]).val();
                    var textareaValuetempDiv = "<div class=\"notes ignore-sorting\">" + textareaValue + "</div>";
                    $(textarea[i]).replaceWith(textareaValuetempDiv);
                }
            }
            var textareaDefect = $(element).find('.ignore-sorting');
        });
    };
    createHtmlToPdfService.prototype.updateStylesToDocument = function (stylesList, tableType) {
        if (tableType === void 0) { tableType = ''; }
        var dynamicStyle = '';
        if (tableType == 'pricingSummary') {
            if (stylesList && stylesList.length) {
                for (var i = 0; i < stylesList.length; i++) {
                    dynamicStyle += ' ' + this.getStyleFromJSON(stylesList[i], tableType);
                    this.findAndremoveWidth(stylesList[i], tableType);
                }
            }
        }
        else if (tableType == 'normalTable') {
            if (stylesList && stylesList.length) {
                for (var i = 0; i < stylesList.length; i++) {
                    dynamicStyle += ' ' + this.getStyleFromJSON(stylesList[i], tableType);
                }
            }
        }
        else {
            if (stylesList && stylesList.length) {
                for (var i = 0; i < stylesList.length; i++) {
                    dynamicStyle += ' ' + this.getStyleFromJSON(stylesList[i], tableType);
                    this.findAndremoveWidth(stylesList[i], tableType);
                }
            }
        }
        this.pdfDatamake.style.push(dynamicStyle);
        if (dynamicStyle != '') {
            this.updateStylesInCSEditor(dynamicStyle, tableType);
        }
    };
    createHtmlToPdfService.prototype.getStyleFromJSON = function (styleData, tableType) {
        if (tableType === void 0) { tableType = ''; }
        var identifier = '';
        var totalSectionIdentifier = '';
        if (tableType == 'pricingSummary') {
            identifier = '#pricing-items-breakup-tpl_' + styleData['currentSectionId'];
            totalSectionIdentifier = '#pricing-summary_total-section_' + styleData['currentSectionId'];
        }
        else if (tableType == 'normalTable') {
            identifier = '#' + styleData['hashId'];
        }
        else {
            identifier = '#Pricing_' + styleData['sectionId'];
            totalSectionIdentifier = '#total_' + styleData['sectionId'];
        }
        var contentBlockBorderWidth = styleData['contentBlockBorderWidthIndividualSide'] ? (styleData.contentBlockBorderWidthTop + 'px ' + styleData.contentBlockBorderWidthRight + 'px ' + styleData.contentBlockBorderWidthBottom + 'px ' + styleData.contentBlockBorderWidthLeft + 'px') : (styleData['contentBlockBorderWidth'] != '' ? styleData['contentBlockBorderWidth'] + 'px' : 0);
        var contentBlockBorderColor = styleData['contentBlockBorderColor'] != 'No colour' ? styleData['contentBlockBorderColor'] : '#ccc';
        var contentBlockBorderRadius = styleData['contentBlockBorderRadiusIndividualSide'] ? (styleData['contentBlockBorderRadiusTopLeft'] + 'px ' + styleData['contentBlockBorderRadiusTopRight'] + 'px ' + styleData['contentBlockBorderRadiusBottomRight'] + 'px ' + styleData['contentBlockBorderRadiusBottomLeft'] + 'px') : (styleData['contentBlockBorderRadius'] != '' ? styleData['contentBlockBorderRadius'] + 'px' : 0);
        var contentBlockBackgroundColor = styleData['contentBlockBackgroundColor'] != 'No background' ? styleData['contentBlockBackgroundColor'] : 'transparent';
        var contentBlockPadding = styleData['contentBlockPaddingIndividualSide'] ? (styleData['contentBlockPaddingTop'] + 'px ' + styleData['contentBlockPaddingRight'] + 'px ' + styleData['contentBlockPaddingBottom'] + 'px ' + styleData['contentBlockPaddingLeft'] + 'px') : (styleData['contentBlockPadding'] != '' ? styleData['contentBlockPadding'] + 'px' : 0);
        var contentBlockMargin = styleData['contentBlockMarginIndividualSide'] ? (styleData['contentBlockMarginTop'] + 'px ' + styleData['contentBlockMarginRight'] + 'px ' + styleData['contentBlockMarginBottom'] + 'px ' + styleData['contentBlockMarginLeft'] + 'px') : (styleData['contentBlockMargin'] != '' ? styleData['contentBlockMargin'] + 'px' : 0);
        var tableBorderWidthToBeAppliedForHeader = styleData['tableBorderWidthIndividualSide'] ? (styleData['tableBorderWidthTop'] + 'px ' + styleData['tableBorderWidthRight'] + 'px ' + styleData['titleTextBorderWidth'] + 'px ' + styleData['tableBorderWidthLeft'] + 'px') : (styleData['tableBorderWidth'] != '' ? (styleData['tableBorderWidth'] + 'px ' + styleData['tableBorderWidth'] + 'px ' + styleData['titleTextBorderWidth'] + 'px ' + styleData['tableBorderWidth'] + 'px') : 0);
        var tableBorderWidthToBeAppliedForBody = styleData['tableBorderWidthIndividualSide'] ? (styleData['titleTextBorderWidth'] + 'px ' + styleData['tableBorderWidthRight'] + 'px ' + styleData['tableBorderWidthBottom'] + 'px ' + styleData['tableBorderWidthLeft'] + 'px') : (styleData['tableBorderWidth'] != '' ? (styleData['titleTextBorderWidth'] + 'px ' + styleData['tableBorderWidth'] + 'px ' + styleData['tableBorderWidth'] + 'px ' + styleData['tableBorderWidth'] + 'px') : 0);
        var tableBorderColor = styleData['tableBorderColor'] != 'No colour' ? styleData['tableBorderColor'] : '#ccc';
        var tableBorderVerticalBorderWidth = styleData['tableBorderVerticalBorderWidth'] != '' ? styleData['tableBorderVerticalBorderWidth'] + 'px' : 1;
        var tableBorderVerticalBorderColor = styleData['tableBorderVerticalBorderColor'] != 'No colour' ? styleData['tableBorderVerticalBorderColor'] : '#ccc';
        var titleHeaderFont = styleData['titleHeaderFont'] != '' ? styleData['titleHeaderFont'] : 'Arial';
        var titleHeaderFontWeight = styleData['titleHeaderFontWeight'] != '' ? styleData['titleHeaderFontWeight'] : 400;
        var titleTextSize = styleData['titleTextSize'] != '' ? styleData['titleTextSize'] : 14;
        var titleTextColor = styleData['titleTextColor'] != 'No colour' ? styleData['titleTextColor'] : '#505B65';
        var titleTextAlignment = styleData['titleTextAlignment'] != '' ? styleData['titleTextAlignment'] : 'left';
        var titleTextHeight = styleData['titleTextHeight'] != '' ? styleData['titleTextHeight'] : 27;
        var titleTextBackgroundColor = styleData['titleTextBackgroundColor'] != 'No background' ? styleData['titleTextBackgroundColor'] : 'transparent';
        var titleTextBorderWidth = styleData['titleTextBorderWidthIndividualSide'] ? (styleData['titleTextBorderWidthTop'] + 'px ' + styleData['titleTextBorderWidthRight'] + 'px ' + styleData['titleTextBorderWidthBottom'] + 'px ' + styleData['titleTextBorderWidthLeft'] + 'px') : (styleData['titleTextBorderWidth'] != '' ? styleData['titleTextBorderWidth'] + 'px' : 1);
        var titleTextBorderColor = styleData['titleTextBorderColor'] != 'No colour' ? styleData['titleTextBorderColor'] : '#ccc';
        var rowHeaderFont = styleData['rowHeaderFont'] != '' ? styleData['rowHeaderFont'] : 'Arial';
        var rowHeaderFontWeight = styleData['rowHeaderFontWeight'] != '' ? styleData['rowHeaderFontWeight'] : 400;
        var rowTextSize = styleData['rowTextSize'] != '' ? styleData['rowTextSize'] : 14;
        var rowTextColor = styleData['rowTextColor'] != 'No colour' ? styleData['rowTextColor'] : '#505B65';
        var rowTextAlignment = styleData['rowTextAlignment'] != '' ? styleData['rowTextAlignment'] : 'left';
        var rowTextHeight = styleData['rowTextHeight'] != '' ? styleData['rowTextHeight'] : 27;
        var rowTextBackgroundColor = styleData['rowTextBackgroundColor'] != 'No background' ? styleData['rowTextBackgroundColor'] : 'transparent';
        var rowTextAlternativeBackgroundColor = styleData['rowTextAlternativeBackgroundColor'] != 'No background' ? styleData['rowTextAlternativeBackgroundColor'] : 'transparent';
        var rowTextHorizontalBorderWidth = styleData['rowTextHorizontalBorderWidth'] != '' ? styleData['rowTextHorizontalBorderWidth'] + 'px' : 1;
        var rowTextHorizontalBorderColor = styleData['rowTextHorizontalBorderColor'] != '' ? styleData['rowTextHorizontalBorderColor'] : '#ccc';
        var totalSummaryBorderWidth = styleData['totalSummaryBorderWidthIndividualSide'] ? (styleData['totalSummaryBorderWidthTop'] + 'px ' + styleData['totalSummaryBorderWidthRight'] + 'px ' + styleData['totalSummaryBorderWidthBottom'] + 'px ' + styleData['totalSummaryBorderWidthLeft'] + 'px') : (styleData['totalSummaryBorderWidth'] != '' ? styleData['totalSummaryBorderWidth'] + 'px' : 0);
        var totalSummaryBorderColor = styleData['totalSummaryBorderColor'] != '' ? styleData['totalSummaryBorderColor'] : '#ccc';
        var totalSummaryBackgroundColor = styleData['totalSummaryBackgroundColor'] != 'No background' ? styleData['totalSummaryBackgroundColor'] : 'transparent';
        var totalSummaryPadding = styleData['totalSummaryPadding'] != '' ? styleData['totalSummaryPadding'] + 'px' : 0;
        var totalSummaryMargin = styleData['totalSummaryMargin'] != '' ? styleData['totalSummaryMargin'] + 'px' : 0;
        var totalSummarySubtotalHeaderFont = styleData['totalSummarySubtotalHeaderFont'] != '' ? styleData['totalSummarySubtotalHeaderFont'] : 'Arial';
        var totalSummarySubtotalHeaderFontWeight = styleData['totalSummarySubtotalHeaderFontWeight'] != '' ? styleData['totalSummarySubtotalHeaderFontWeight'] : 400;
        var totalSummarySubtotalTextSize = styleData['totalSummarySubtotalTextSize'] != '' ? styleData['totalSummarySubtotalTextSize'] : 14;
        var totalSummarySubtotalTextColor = styleData['totalSummarySubtotalTextColor'] != 'No colour' ? styleData['totalSummarySubtotalTextColor'] : '#505B65';
        var totalSummarySubtotalLineHeight = styleData['totalSummarySubtotalLineHeight'] != '' ? styleData['totalSummarySubtotalLineHeight'] : 14;
        var totalSummaryGrandTotalHeaderFont = styleData['totalSummaryGrandTotalHeaderFont'] != '' ? styleData['totalSummaryGrandTotalHeaderFont'] : 'Arial';
        var totalSummaryGrandTotalHeaderFontWeight = styleData['totalSummaryGrandTotalHeaderFontWeight'] != '' ? styleData['totalSummaryGrandTotalHeaderFontWeight'] : 400;
        var totalSummaryGrandTotalTextSize = styleData['totalSummaryGrandTotalTextSize'] != '' ? styleData['totalSummaryGrandTotalTextSize'] : 14;
        var totalSummaryGrandTotalTextColor = styleData['totalSummaryGrandTotalTextColor'] != 'No colour' ? styleData['totalSummaryGrandTotalTextColor'] : '#505B65';
        var totalSummaryGrandTotalLineHeight = styleData['totalSummaryGrandTotalLineHeight'] != '' ? styleData['totalSummaryGrandTotalLineHeight'] : 14;
        var financeFontStyle = (styleData['financeFontStyle'] && styleData['financeFontStyle'] != '') ? styleData['financeFontStyle'] : 'Arial';
        var financeFontSize = (styleData['financeFontSize'] && styleData['financeFontSize'] != '') ? styleData['financeFontSize'] : 14;
        var financeTextColor = (styleData['financeTextColor'] && styleData['financeTextColor'] != 'No colour') ? styleData['financeTextColor'] : '#505B65';
        var financeLineHeight = (styleData['financeLineHeight'] && styleData['financeLineHeight'] != '') ? styleData['financeLineHeight'] : 20;
        var grantsFontStyle = (styleData['grantsFontStyle'] && styleData['grantsFontStyle'] != '') ? styleData['grantsFontStyle'] : 'Arial';
        var grantsFontWeight = (styleData['grantsFontWeight'] && styleData['grantsFontWeight'] != '') ? styleData['grantsFontWeight'] : 400;
        var grantsFontSize = (styleData['grantsFontSize'] && styleData['grantsFontSize'] != '') ? styleData['grantsFontSize'] : 14;
        var grantsTextColor = (styleData['grantsTextColor'] && styleData['grantsTextColor'] != 'No colour') ? styleData['grantsTextColor'] : '#505B65';
        var grantsLineHeight = (styleData['grantsLineHeight'] && styleData['grantsLineHeight'] != '') ? styleData['grantsLineHeight'] : 14;
        var dynamicStyle = identifier + " " + (styleData.isNormalTable ? 'div.froala-table' : '') + " {\n            border-width: " + contentBlockBorderWidth + ";\n            border-style: solid;\n            border-color: " + contentBlockBorderColor + ";\n            background: " + contentBlockBackgroundColor + ";\n            padding: " + contentBlockPadding + ";\n            border-radius: " + contentBlockBorderRadius + ";\n            margin: " + contentBlockMargin + ";\n    }\n\n    " + identifier + " table thead{\n            border-width: " + tableBorderWidthToBeAppliedForHeader + ";\n            border-right-style: solid;\n            border-left-style: solid;\n            border-top-style: solid;\n            border-right-color: " + tableBorderColor + ";\n            border-left-color: " + tableBorderColor + ";\n            border-top-color: " + tableBorderColor + ";\n    }\n    " + identifier + " table tbody{\n            border-width: " + tableBorderWidthToBeAppliedForBody + ";\n            border-right-style: solid;\n            border-left-style: solid;\n            border-bottom-style: solid;\n            border-right-color: " + tableBorderColor + ";\n            border-left-color: " + tableBorderColor + ";\n            border-bottom-color: " + tableBorderColor + ";\n    }\n    " + identifier + " table thead tr th,\n    " + identifier + " table tbody tr td {\n        border-left-width: " + tableBorderVerticalBorderWidth + ";\n        border-left-style: solid;\n        border-left-color: " + tableBorderVerticalBorderColor + ";\n        border-right-width: " + tableBorderVerticalBorderWidth + ";\n        border-right-style: solid;\n        border-right-color: " + tableBorderVerticalBorderColor + ";\n    }\n    " + identifier + " table thead tr{\n         border-width: " + titleTextBorderWidth + ";\n         border-style: solid;\n         border-color: " + titleTextBorderColor + ";\n    }\n    " + identifier + " table thead tr th{\n            font-family: " + titleHeaderFont + ";\n            font-weight: " + titleHeaderFontWeight + " !important;\n            font-size: " + titleTextSize + "px !important;\n            text-align: " + titleTextAlignment + ";\n            height: " + titleTextHeight + "px;\n            color: " + titleTextColor + " !important;\n            background-color: " + titleTextBackgroundColor + ";\n    }\n    " + identifier + " table tbody tr:nth-child(odd) td{\n            font-family: " + rowHeaderFont + ";\n            font-weight: " + rowHeaderFontWeight + ";\n            font-size: " + rowTextSize + "px !important;\n            text-align: " + rowTextAlignment + ";\n            color: " + rowTextColor + " !important;\n            background-color: " + rowTextBackgroundColor + ";\n        }\n         " + identifier + " tbody tr:nth-child(even) td{\n            font-family: " + rowHeaderFont + ";\n            font-weight: " + rowHeaderFontWeight + ";\n            font-size: " + rowTextSize + "px !important;\n            text-align: " + rowTextAlignment + ";\n            color: " + rowTextColor + " !important;\n            background-color: " + rowTextAlternativeBackgroundColor + ";\n        }\n\n        " + identifier + " tbody tr td .desc{\n            font-family: " + rowHeaderFont + ";\n            font-weight: " + rowHeaderFontWeight + ";\n            font-size: " + rowTextSize + "px !important;\n            text-align: " + rowTextAlignment + ";\n            color: " + rowTextColor + " !important;\n            }\n            " + identifier + " table tr td .notes{\n            font-family: " + rowHeaderFont + ";\n            font-weight: " + rowHeaderFontWeight + ";\n            font-size: " + rowTextSize + "px !important;\n            text-align: " + rowTextAlignment + ";\n            color: " + rowTextColor + " !important;\n         }\n         " + identifier + " tbody tr td .pricing-section-part-no-images{\n            text-align : " + rowTextAlignment + ";\n            width: 92%;\n         }\n        " + identifier + " table tbody tr.mousehoverNew{\n            height: " + rowTextHeight + "px;\n        }\n        " + identifier + " table tbody tr {\n            border-bottom-width : " + rowTextHorizontalBorderWidth + ";\n            border-bottom-style: solid;\n            border-bottom-color: " + rowTextHorizontalBorderColor + ";\n        }\n        " + identifier + " table tfoot.pricingSection_subGrandTotalBlock{\n            border-width: " + totalSummaryBorderWidth + ";\n            border-style: solid;\n            border-color: " + totalSummaryBorderColor + ";\n        }\n        " + identifier + " table tfoot tr{\n            background-color: " + totalSummaryBackgroundColor + " !important;\n        }\n\n        " + identifier + " table tfoot tr td div.subtotal-style-apply-here{\n            font-family: " + totalSummarySubtotalHeaderFont + ";\n            font-weight: " + totalSummarySubtotalHeaderFontWeight + " !important;\n            font-size: " + totalSummarySubtotalTextSize + "px !important;\n            color: " + totalSummarySubtotalTextColor + " !important;\n            line-height: " + totalSummarySubtotalLineHeight + "px !important;\n        }\n        " + identifier + " table tfoot tr td div.grand-total-style-apply-here{\n            font-family: " + totalSummaryGrandTotalHeaderFont + ";\n            font-weight: " + totalSummaryGrandTotalHeaderFontWeight + " !important;\n            font-size: " + totalSummaryGrandTotalTextSize + "px !important;\n            color: " + totalSummaryGrandTotalTextColor + " !important;\n            line-height: " + totalSummaryGrandTotalLineHeight + "px !important;\n        }\n        " + identifier + " table tfoot tr td.finance-section-new-improvement {\n            font-family: " + financeFontStyle + ";\n            font-size: " + financeFontSize + "px !important;\n            color: " + financeTextColor + " !important;\n            line-height: " + financeLineHeight + "px !important;\n        }\n        " + identifier + " table tfoot tr td div.grants-style-apply-here {\n            font-family: " + grantsFontStyle + ";\n            font-weight: " + grantsFontWeight + " !important;\n            font-size: " + grantsFontSize + "px !important;\n            color: " + grantsTextColor + " !important;\n            line-height: " + grantsLineHeight + "px !important;\n        }\n        ";
        // //pricing section image alignment css
        // if(rowAlignment == 'left' || rowAlignment == 'justify') {
        //     dynamicStyle += `${identifier} .show-image{
        //     transform: translateX(5px);
        //     }`
        // } else if(rowAlignment == 'center'){
        //     dynamicStyle += `${identifier} .show-image{
        //     transform: translateX(85px);
        //     }`
        // }else if(rowAlignment == 'right') {
        //     dynamicStyle += `${identifier} .show-image{
        //     transform: translateX(173px);
        //     }`
        // }
        if (tableType == 'normalTable') {
            dynamicStyle += identifier + " div.froala-table{\n            border-radius: " + contentBlockBorderRadius + ";\n            overflow: hidden;\n        }";
        }
        else {
            dynamicStyle += identifier + " {\n            border-radius: " + contentBlockBorderRadius + ";\n            overflow: hidden;\n        }";
        }
        return dynamicStyle;
    };
    createHtmlToPdfService.prototype.findAndremoveWidth = function (styleData, tableType) {
        if (tableType === void 0) { tableType = ''; }
        var sectionId = styleData['sectionId'];
        var identifier = tableType === 'pricingSummary'
            ? "#pricing-items-breakup-tpl_" + sectionId
            : "#Pricing_" + sectionId;
        var placeEverythingElement = $(this.bodyHtmlContent).get(0);
        if (placeEverythingElement) {
            var self_1 = $(placeEverythingElement).find('#place_everything');
            if (self_1 && identifier.startsWith('#')) {
                var findTable = self_1.querySelectorAll(identifier);
                if (findTable && findTable.length) {
                    $(findTable).css({ 'width': '' });
                }
            }
        }
    };
    createHtmlToPdfService.prototype.updateStylesInCSEditor = function (dynamicStyle, tableType) {
        if (tableType === void 0) { tableType = ''; }
        var style;
        //TODO: seperate to option summary style and option table style and create dynamic style
        var doc = $(this.bodyHtmlContent);
        if (tableType == 'pricingSummary') {
            style = $(this.bodyHtmlContent).find('#dynamic_styling_summary');
        }
        else if (tableType == 'normalTable') {
            style = $(this.bodyHtmlContent).find('#dynamic_styling_normal');
        }
        else {
            style = $(this.bodyHtmlContent).find('#dynamic_styling');
        }
        if (style && style.length) {
            return;
        }
        if (!style) {
            style = document.createElement('style');
            if (tableType == 'pricingSummary') {
                style.id = "dynamic_styling_summary";
            }
            else if (tableType == 'normalTable') {
                style.id = "dynamic_styling_normal";
            }
            else {
                style.id = "dynamic_styling";
            }
        }
        style.innerHTML = dynamicStyle;
        // Get the first script tag
        var ref = document.querySelector('script');
        var placeEverythingElement = $(this.bodyHtmlContent).get(0);
        var self = $(placeEverythingElement).find('#place_everything');
        if (self) {
            $(placeEverythingElement).contents().find("head")[0].appendChild(style);
        }
    };
    createHtmlToPdfService.prototype.youtubeThumbnailRendering = function (body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var child, promises, _i, child_1, element, extractedData;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        child = body.querySelectorAll('.cs_page');
                        promises = [];
                        _i = 0, child_1 = child;
                        _a.label = 1;
                    case 1:
                        if (!(_i < child_1.length)) return [3 /*break*/, 4];
                        element = child_1[_i];
                        return [4 /*yield*/, this.extractDataFromHTML(element)];
                    case 2:
                        extractedData = _a.sent();
                        promises.push(this.youtubeAndLoomVideoRendering(extractedData, element));
                        _a.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [4 /*yield*/, Promise.all(promises)];
                    case 5:
                        _a.sent();
                        this.sendButtonDisabled = true;
                        this.sendtoCustomerLoading = false;
                        setTimeout(function () {
                            _this.domRederingImagesElement();
                        }, 2000);
                        return [2 /*return*/];
                }
            });
        });
    };
    createHtmlToPdfService.prototype.extractDataFromHTML = function (html) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var videoBlocks, csBlocks;
            return tslib_1.__generator(this, function (_a) {
                videoBlocks = [];
                csBlocks = html.querySelectorAll('.cs_block_s[tag="video"]');
                csBlocks.forEach(function (csBlock) {
                    var dynamicId = csBlock.getAttribute('id') || '';
                    var iframe = csBlock.querySelector('iframe');
                    if (iframe == null) {
                        return;
                    }
                    var styleAttr = iframe.getAttribute('style') || '';
                    var styles = styleAttr.split(';').reduce(function (acc, style) {
                        var _a = style.split(':').map(function (s) { return s.trim(); }), property = _a[0], value = _a[1];
                        acc[property] = value;
                        return acc;
                    }, {});
                    var youtubeUrl = iframe.getAttribute('src') || '';
                    var youtubeURLorLoomURL = youtubeUrl.includes('youtube') ? 'youtube' : 'loom';
                    videoBlocks.push({ dynamicId: dynamicId, IframeImageType: youtubeURLorLoomURL, style: styles, youtubeUrl: youtubeUrl });
                });
                return [2 /*return*/, videoBlocks];
            });
        });
    };
    createHtmlToPdfService.prototype.youtubeAndLoomVideoRendering = function (data, element) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _i, data_1, blockData;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _i = 0, data_1 = data;
                        _a.label = 1;
                    case 1:
                        if (!(_i < data_1.length)) return [3 /*break*/, 6];
                        blockData = data_1[_i];
                        if (!(blockData.IframeImageType === 'youtube')) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.createVideoDivElements(blockData, element, 'youtube')];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.createVideoDivElements(blockData, element, 'loom')];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        _i++;
                        return [3 /*break*/, 1];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    createHtmlToPdfService.prototype.domRederingImagesElement = function () {
        var _this = this;
        var placeEverythingElement = $(this.bodyHtmlContent).get(0);
        if (placeEverythingElement) {
            var findDivElement = $(placeEverythingElement).find('#place_everything');
            ;
            var body = findDivElement.querySelectorAll('.cs_page');
            var child = body;
            child.forEach(function (page) {
                var imageElements = page.querySelectorAll('[tag="Image"]');
                var videoElements = page.querySelectorAll('[tag="Video"]');
                var pricingsectionElements = page.querySelectorAll('[tag="pricingsection"]');
                var optionspricingbreakupElements = page.querySelectorAll('[tag="Summary"]');
                imageElements.forEach(function (elem) {
                    if ($(elem).find('.img-btn').length == 0) {
                        var imgDiv = $(elem).find('img').get(0);
                        var imgWidth = $(imgDiv).css('width');
                        var imgHeight = $(imgDiv).css('height');
                        $(imgDiv).css({ 'width': imgWidth, 'height': imgHeight });
                    }
                });
                videoElements.forEach(function (elem) {
                    if ($(elem).find('.img-btn').length == 0) {
                        var videoContainer = $(elem).find('.thumbnail-image').get(0);
                        var width = $(videoContainer).css('width');
                        var height = $(videoContainer).css('height');
                        $(videoContainer).css({ 'width': width, 'height': height });
                        $(videoContainer).css({ 'max-width': '', 'max-height': '' });
                    }
                });
                if (pricingsectionElements && pricingsectionElements.length) {
                    _this.adjustFinanceSectionHeight(pricingsectionElements);
                }
                if (optionspricingbreakupElements && optionspricingbreakupElements.length) {
                    _this.adjustFinanceSectionHeight(optionspricingbreakupElements);
                }
            });
        }
        if (!this.proposalValueMismatch && !this.proposalValueMismatchError) {
            this.getCsPageList();
        }
    };
    createHtmlToPdfService.prototype.createVideoDivElements = function (data, element, type) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var container, newDiv, thumbnailImg, _a, _b, playButton, iconElement, handleSectionSummary;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        container = $(element).find("#" + data.dynamicId);
                        newDiv = document.createElement('div');
                        newDiv.classList.add('new-video-block');
                        newDiv.style.width = "-webkit-fill-available";
                        if (type == 'loom') {
                            newDiv.classList.add('loom-video-element-thumbnail');
                        }
                        thumbnailImg = document.createElement('img');
                        thumbnailImg.classList.add('thumbnail-image');
                        _a = thumbnailImg;
                        if (!(type === 'youtube')) return [3 /*break*/, 1];
                        _b = "https://img.youtube.com/vi/" + data.youtubeUrl.split('/').pop() + "/mqdefault.jpg";
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.fetchLoomThumbnail(data.youtubeUrl)];
                    case 2:
                        _b = _c.sent();
                        _c.label = 3;
                    case 3:
                        _a.src = _b;
                        thumbnailImg.alt = 'Video Thumbnail';
                        Object.entries(data.style).forEach(function (_a) {
                            var property = _a[0], value = _a[1];
                            thumbnailImg.style[property] = value;
                        });
                        playButton = document.createElement('div');
                        playButton.classList.add("play-button-" + type);
                        iconElement = document.createElement("i");
                        iconElement.className = "fa fa-play";
                        iconElement.classList.add("play-icon-button-" + type);
                        iconElement.setAttribute("aria-hidden", "true");
                        playButton.appendChild(iconElement);
                        // playButton.setAttribute('onclick', `showIframe('${data.youtubeUrl+'?autoplay=1'}', '${data.dynamicId}','${type}')`);
                        newDiv.appendChild(thumbnailImg);
                        newDiv.appendChild(playButton);
                        container.append(newDiv);
                        handleSectionSummary = function (container) {
                            var removeIframe = container.find('iframe');
                            removeIframe.remove();
                        };
                        handleSectionSummary(container);
                        return [2 /*return*/];
                }
            });
        });
    };
    createHtmlToPdfService.prototype.adjustFinanceSectionHeight = function (elements) {
        if (elements && elements.length) {
            for (var i = 0; i < elements.length; i++) {
                var getTableElement = $(elements[i]).find('table');
                if (getTableElement && getTableElement.length) {
                    var getFinanceSection = $(getTableElement).find('.finance-section-new-improvement');
                    if (getFinanceSection && getFinanceSection.length && $(getFinanceSection).attr('breakdown-status') == 'horizontal') {
                        var financeHeight = $(getFinanceSection).height();
                        var parentElement = getFinanceSection.parent();
                        if (parentElement && parentElement.length) {
                            var firstTD = $(parentElement).find('.total-section-right-text-label').parent();
                            var secondTD = $(parentElement).find('.total-section-right-text-value').parent();
                            if (firstTD && firstTD.length && secondTD && secondTD.length) {
                                $(firstTD).css('height', financeHeight);
                                $(secondTD).css('height', financeHeight);
                            }
                        }
                    }
                }
            }
        }
    };
    createHtmlToPdfService.prototype.fetchLoomThumbnail = function (videoUrl) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var apiUrl, response, data, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        apiUrl = "https://www.loom.com/v1/oembed?url=https://www.loom.com/share/" + videoUrl.split('/').pop();
                        return [4 /*yield*/, fetch(apiUrl)];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) {
                            throw new Error("Error fetching Loom oEmbed data. Status: " + response.status);
                        }
                        return [4 /*yield*/, response.json()];
                    case 2:
                        data = _a.sent();
                        return [2 /*return*/, data.thumbnail_url];
                    case 3:
                        error_1 = _a.sent();
                        console.error('Error:', error_1.message);
                        throw error_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    createHtmlToPdfService.prototype.getCsPageList = function () {
        var placeEverythingElement = $(this.bodyHtmlContent).get(0);
        if (placeEverythingElement) {
            this.pagesDataList = $(placeEverythingElement).find('.cs_page');
            var userConfigDetails = this.authService;
            this.pdfDatamake['countryName'] = userConfigDetails['settings']['_csCountryCode']['country'].replaceAll(' ', '').toLowerCase();
            this.pdfDatamake['opportunitiesProposalID'] = this.opportunityProposalId;
            this.pdfDatamake.htmldata = [];
            for (var i = 0; i < this.pagesDataList.length; i++) {
                this.pdfDatamake.htmldata.push(this.pagesDataList[i].outerHTML);
            }
            this.htmltoPdfConversation();
        }
    };
    createHtmlToPdfService.prototype.callOpportunitiesPages = function (opportunityId, proposalId, body) {
        this.opportunitiesPages(opportunityId, proposalId, body);
    };
    createHtmlToPdfService.prototype.htmltoPdfConversation = function () {
        var _this = this;
        this.opportunityService.generatePdfFiles(this.opportunityId, this.pdfDatamake).subscribe(function (responseData) {
            if (responseData && responseData.hasOwnProperty('pdfFilePath')) {
                var data = {
                    'type': 'email',
                    'fileName': "PROPOSAL_" + _this.opportunityId + "_" + _this.opportunityProposalId + "_1.pdf",
                    //PROPOSAL_3187_2844_1.pdf
                    'pdfData': {
                        'id': 'ProposalPDF',
                        'name': "PROPOSAL_" + _this.opportunityId + "_" + _this.opportunityProposalId + "_1.pdf",
                        'location': '',
                        'size': 500,
                        'filetype': 'pdf',
                        'opportunityId': _this.opportunityId,
                        'selected': false,
                        'attached': false
                    },
                };
                _this.setPdfData(data);
                _this.sendButtonDisabled = false;
                _this.sendtoCustomerLoading = false;
            }
        });
    };
    createHtmlToPdfService.prototype.setPdfData = function (data) {
        this.defectDetails.next(data);
    };
    createHtmlToPdfService.ngInjectableDef = i0.defineInjectable({ factory: function createHtmlToPdfService_Factory() { return new createHtmlToPdfService(i0.inject(i1.BsModalRef), i0.inject(i2.DomSanitizer), i0.inject(i3.AddOpportunityService), i0.inject(i4.AuthService)); }, token: createHtmlToPdfService, providedIn: "root" });
    return createHtmlToPdfService;
}(InterfaceService));
export { createHtmlToPdfService };
